var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgChat = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "24px",
    viewBox: "0 0 23 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "chat icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 4.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16.5,
    cy: 7.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,20 L12,14 L3,14 C1,14 0,13 0,11 C0,9 0,6.33333333 0,3 C0,1 1,0 3,0 C5,0 10,0 18,0 C20,0 21,1 21,3 C21,5 21,7.66666667 21,11 C21,13 20,14 18,14",
    id: "Path-29",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat.03945927.svg";
export { ForwardRef as ReactComponent };